(function () {

  function initBGSResults() {

    var root =
      document.querySelector(
        '[data-bgs-results]'
      );

    if (!root) return;


    var PDF_LOGO =
      root.getAttribute(
        'data-pdf-logo'
      ) || '';


    /* =====================================================
       PERSONALITY DATA
    ===================================================== */

    var ARCHETYPES = {

      A: {
        article: 'an',
        name: 'Analytical Perfectionist',
        subtitle: 'Data-driven. Structured. Precise.',
        description:
          'You tend to build confidence through research, evidence, probabilities, and preparation. You usually feel strongest when you understand why a setup makes sense and have clear rules for entering, managing, and reviewing the trade.',
        tags: [
          'Data-Driven',
          'Structured',
          'Probability Focused'
        ],
        blend:
          'Your Analytical Perfectionist side wants evidence and structure before acting. Your secondary style adds another layer to that process, influencing how quickly you act, how much risk you accept, and what kinds of opportunities feel most natural.',
        coreDrive:
          'Build confidence through evidence and preparation.',
        decisionStyle:
          'You prefer to understand the setup, probabilities, and rules before committing capital.',
        bestEnvironment:
          'Clear setups, measurable criteria, repeatable processes, and enough time to evaluate information.',
        pressurePattern:
          'Under pressure, analysis can become hesitation. More information can start to feel like the solution even when your criteria have already been met.',
        strengths: [
          'You naturally look for evidence before committing capital.',
          'You value repeatable rules and clearly defined decision criteria.',
          'You tend to review mistakes analytically rather than relying only on emotion.',
          'You can become highly consistent when your process is clearly defined.'
        ],
        best: [
          'Strategies with objective entry and exit criteria.',
          'Setups that can be backtested, tracked, and reviewed.',
          'Trading routines that include preparation before execution.',
          'Markets where you can distinguish signal from random noise.'
        ],
        watchouts: [
          'Analysis paralysis can delay otherwise valid entries.',
          'You may continue researching after your decision criteria are already satisfied.',
          'Over-optimization can make execution unnecessarily complicated.',
          'A losing trade can tempt you to rebuild an entire system instead of accepting normal variance.'
        ],
        guardrails: [
          'Define exactly what information is required before a trade.',
          'Create a deadline for analysis so research does not become avoidance.',
          'Track whether the trade followed your process separately from whether it won.',
          'Review systems on a schedule instead of changing rules after every loss.'
        ]
      },

      B: {
        article: 'an',
        name: 'Adrenaline Junkie',
        subtitle: 'Fast-moving. Decisive. Action-oriented.',
        description:
          'You are energized by movement, speed, and real-time decision-making. You tend to enjoy environments where conditions change quickly and decisive execution matters. Your strongest trading framework will usually give you enough activity to stay engaged while placing firm boundaries around risk.',
        tags: [
          'Fast-Paced',
          'Decisive',
          'Action Oriented'
        ],
        blend:
          'Your Adrenaline Junkie side is energized by movement, speed, and decisive action. Your secondary style changes how that energy gets expressed — adding another influence to the way you evaluate opportunities, manage risk, and decide when to step in or step away.',
        coreDrive:
          'Engage with movement and act decisively when opportunity appears.',
        decisionStyle:
          'You are generally more comfortable making fast decisions with incomplete information than waiting for every variable to become certain.',
        bestEnvironment:
          'Active conditions, meaningful price movement, clear catalysts, and defined windows for execution.',
        pressurePattern:
          'Under pressure, speed can turn into urgency. Activity may start to feel productive even when the better decision is to wait.',
        strengths: [
          'You can make decisions quickly when conditions are moving.',
          'You are often comfortable adapting in real time.',
          'You may stay engaged in environments that overwhelm slower decision-makers.',
          'You can act decisively when your criteria are clear.'
        ],
        best: [
          'Defined trading windows with enough movement to stay engaged.',
          'Setups where execution rules are clear before the action starts.',
          'Strategies that provide feedback quickly without requiring constant improvisation.',
          'A process that separates legitimate opportunity from the desire to simply be active.'
        ],
        watchouts: [
          'Overtrading when the market does not provide a real setup.',
          'Chasing after missing a move.',
          'Increasing position size because confidence or excitement is elevated.',
          'Mistaking speed for edge.'
        ],
        guardrails: [
          'Set a maximum number of trades before the session starts.',
          'Predefine entries, exits, stops, and invalidation points.',
          'Use a cooldown rule after a large win or loss.',
          'Track impulsive trades separately so activity can be measured honestly.'
        ]
      },

      C: {
        article: 'a',
        name: 'Patient Hunter',
        subtitle: 'Selective. Calm. Timing-focused.',
        description:
          'You tend to value patience, timing, and selectivity. You are often more comfortable waiting for a setup to develop than forcing activity, and you may perform best when your process rewards discipline rather than constant participation.',
        tags: [
          'Patient',
          'Selective',
          'Timing Focused'
        ],
        blend:
          'Your Patient Hunter side is built around selectivity and timing. Your secondary style influences what finally convinces you to act and how you manage the position once you are in it.',
        coreDrive:
          'Wait for high-quality opportunities rather than manufacture action.',
        decisionStyle:
          'You are comfortable letting information develop and often prefer confirmation before acting.',
        bestEnvironment:
          'Clear trends, quality setups, and enough time for a thesis to develop without constant intervention.',
        pressurePattern:
          'Under pressure, patience can become hesitation or frustration when the market refuses to provide the clean setup you want.',
        strengths: [
          'You can sit out when conditions do not meet your standards.',
          'You are naturally suited to selective execution.',
          'You may be less vulnerable to constant market noise.',
          'You can allow positions time to develop when the setup remains valid.'
        ],
        best: [
          'Swing and position-style frameworks.',
          'Trend and structure-based setups.',
          'Alert-driven routines that reduce unnecessary screen time.',
          'Processes that reward quality over frequency.'
        ],
        watchouts: [
          'Waiting so long that a valid opportunity passes.',
          'Expecting every setup to become perfectly clean.',
          'Entering early because patience finally turns into frustration.',
          'Becoming too attached to a setup after waiting a long time for it.'
        ],
        guardrails: [
          'Define minimum criteria rather than waiting for perfection.',
          'Use alerts to reduce unnecessary monitoring.',
          'Separate patient waiting from fear-based hesitation.',
          'Document why a setup qualified before entering.'
        ]
      },

      D: {
        article: 'a',
        name: 'Risk-Averse Calculator',
        subtitle: 'Protective. Deliberate. Risk-conscious.',
        description:
          'You tend to evaluate opportunity through the lens of downside protection. Preserving capital, controlling exposure, and reducing unnecessary stress may matter as much as the potential return itself.',
        tags: [
          'Risk-Aware',
          'Protective',
          'Deliberate'
        ],
        blend:
          'Your Risk-Averse Calculator side prioritizes capital protection and clearly defined downside. Your secondary style influences where you are willing to take risk and what gives you enough confidence to participate.',
        coreDrive:
          'Protect capital and avoid unnecessary exposure.',
        decisionStyle:
          'You often evaluate the downside first and feel more comfortable when risk is known before the trade begins.',
        bestEnvironment:
          'Defined-risk structures, lower-maintenance processes, and clear limits on exposure.',
        pressurePattern:
          'Under pressure, caution can become avoidance, premature exits, or position sizing so small that the strategy becomes difficult to evaluate.',
        strengths: [
          'You naturally think about downside before upside.',
          'You are more likely to respect risk limits.',
          'You may be comfortable passing on trades that feel unnecessarily aggressive.',
          'You can build durable processes around capital preservation.'
        ],
        best: [
          'Defined-risk positions and clearly capped losses.',
          'Rules-based swing or income-oriented research.',
          'Lower-frequency processes with scheduled reviews.',
          'Strategies that do not require constant screen monitoring.'
        ],
        watchouts: [
          'Exiting valid trades early simply because they fluctuate.',
          'Avoiding opportunities because any loss feels unacceptable.',
          'Focusing so heavily on win rate that risk/reward becomes distorted.',
          'Confusing low activity with low risk.'
        ],
        guardrails: [
          'Define acceptable loss before entry rather than reacting afterward.',
          'Evaluate risk and reward together.',
          'Use position sizing rules instead of emotion-based sizing.',
          'Review whether early exits improved or harmed your results.'
        ]
      },

      E: {
        article: 'a',
        name: 'Contrarian Rebel',
        subtitle: 'Independent. Sentiment-aware. Opportunistic.',
        description:
          'You tend to notice crowd behavior, emotional extremes, and situations where consensus may have moved too far. You value independent thinking and may naturally look for opportunities that other traders overlook.',
        tags: [
          'Independent',
          'Contrarian',
          'Sentiment Aware'
        ],
        blend:
          'Your Contrarian Rebel side looks for crowd extremes and opportunities outside the obvious consensus. Your secondary influence changes how aggressively you act on that view and how much confirmation you require first.',
        coreDrive:
          'Find opportunity where crowd behavior may have become stretched.',
        decisionStyle:
          'You are comfortable forming an independent view and may question trades that feel too universally accepted.',
        bestEnvironment:
          'Emotional markets, sentiment extremes, stretched moves, and conditions where crowd positioning becomes relevant.',
        pressurePattern:
          'Under pressure, independent thinking can turn into stubbornness. Being different can become more important than responding to what the market is actually doing.',
        strengths: [
          'You naturally question consensus instead of automatically following it.',
          'You may recognize emotional extremes that others overlook.',
          'You can think independently when crowd behavior becomes intense.',
          'You are comfortable looking for non-obvious opportunities.'
        ],
        best: [
          'Research involving sentiment, positioning, or extreme conditions.',
          'Mean-reversion frameworks with objective confirmation.',
          'Processes that distinguish a stretched market from a genuinely strong trend.',
          'Strategies with explicit invalidation when the crowd is actually right.'
        ],
        watchouts: [
          'Fighting strong trends simply because they look crowded.',
          'Entering reversals before there is evidence of exhaustion.',
          'Holding a losing view because changing your mind feels like following the crowd.',
          'Overvaluing being early or different.'
        ],
        guardrails: [
          'Require objective reversal or exhaustion criteria.',
          'Define exactly what proves the contrarian thesis wrong.',
          'Do not add simply because the market moves further against you.',
          'Track how often extreme sentiment actually produced the reversal you expected.'
        ]
      }

    };


    var SECTION_NAMES = {
      1: 'Decision-Making',
      2: 'Risk & Position Management',
      3: 'Lifestyle & Availability',
      4: 'Emotional Tendencies',
      5: 'Market & Strategy Fit',
      6: 'Experience & Growth'
    };


    var SECTION_RANGES = {
      1: [1, 8],
      2: [9, 16],
      3: [17, 24],
      4: [25, 34],
      5: [35, 42],
      6: [43, 50]
    };


    var STRATEGIES = {

      A: [
        {
          name: 'Defined-Risk Options Structures',
          summary:
            'Research spreads and other defined-risk structures where probabilities, maximum loss, and trade parameters can be evaluated before entry.',
          why:
            'This may fit your preference for measurable risk, structure, and repeatable decision criteria.',
          watch:
            'Avoid over-engineering the position until execution becomes unnecessarily complicated.',
          fit:
            'Strong Research Fit'
        },
        {
          name: 'Rules-Based Swing Trading',
          summary:
            'Research multi-day setups built around objective trend, structure, or indicator criteria with predefined entries and exits.',
          why:
            'This gives you time to analyze without requiring constant intraday decisions.',
          watch:
            'Do not add so many filters that no setup can ever qualify.',
          fit:
            'Strong Research Fit'
        },
        {
          name: 'Systematic Mean Reversion',
          summary:
            'Study objective definitions for extension, exhaustion, confirmation, and invalidation rather than relying on feel.',
          why:
            'A systematic framework can turn a reversal idea into something measurable and reviewable.',
          watch:
            'Backtested behavior does not guarantee future performance.',
          fit:
            'Secondary Research Fit'
        }
      ],

      B: [
        {
          name: 'Structured Intraday Momentum',
          summary:
            'Research highly liquid instruments, catalyst-driven movement, predetermined entry triggers, hard stops, and a defined trading window.',
          why:
            'This may give you the movement and feedback you enjoy while forcing fast decisions into a controlled framework.',
          watch:
            'Activity can easily turn into overtrading when there is no real setup.',
          fit:
            'Strong Research Fit'
        },
        {
          name: 'Opening-Range Systems',
          summary:
            'Explore objective opening-range breakouts or failed breakouts using a defined trading window, specific triggers, and maximum loss rules.',
          why:
            'The opening session can provide concentrated movement without requiring you to trade every hour of the day.',
          watch:
            'Do not chase after the initial move has already extended beyond your criteria.',
          fit:
            'Strong Research Fit'
        },
        {
          name: 'Short-Duration Swing Trading',
          summary:
            'Research one-to-several-day setups that still provide meaningful movement without requiring continuous screen exposure.',
          why:
            'This can preserve some of the pace you enjoy while fitting traders who cannot monitor every tick.',
          watch:
            'Holding overnight introduces different risks than intraday trading.',
          fit:
            'Flexible Research Fit'
        },
        {
          name: 'Mean-Reversion Trading',
          summary:
            'Research objective definitions for extension, exhaustion, confirmation, and invalidation instead of automatically fading every strong move.',
          why:
            'This may fit particularly well when your secondary style is drawn to emotional extremes.',
          watch:
            'Strong trends can stay stretched longer than expected.',
          fit:
            'Secondary Research Fit'
        }
      ],

      C: [
        {
          name: 'Swing Trading',
          summary:
            'Research multi-day setups that allow price structure and the trade thesis time to develop.',
          why:
            'This aligns with patience, selectivity, and a preference for fewer higher-quality decisions.',
          watch:
            'Waiting for perfection can cause missed entries.',
          fit:
            'Strong Research Fit'
        },
        {
          name: 'Trend Following',
          summary:
            'Explore objective trend definitions, pullback entries, continuation setups, and trailing exit methods.',
          why:
            'Trend frameworks can reward your willingness to wait for structure and remain patient once positioned.',
          watch:
            'No trend persists forever; invalidation still matters.',
          fit:
            'Strong Research Fit'
        },
        {
          name: 'Position Trading',
          summary:
            'Research longer-duration frameworks that require less frequent decision-making.',
          why:
            'This may fit traders who prefer lower frequency and less intraday noise.',
          watch:
            'Longer holding periods can involve larger price swings and overnight risk.',
          fit:
            'Flexible Research Fit'
        }
      ],

      D: [
        {
          name: 'Defined-Risk Options Spreads',
          summary:
            'Research structures where maximum loss and reward characteristics are known before the position is opened.',
          why:
            'Defined downside may fit your preference for controlling risk before committing capital.',
          watch:
            'Defined risk does not mean low risk or guaranteed profit.',
          fit:
            'Strong Research Fit'
        },
        {
          name: 'Cash-Secured & Covered Strategies',
          summary:
            'Research income-oriented options structures after understanding assignment risk, capital requirements, and underlying exposure.',
          why:
            'These structures may appeal to traders who prefer slower, rule-based processes.',
          watch:
            'Income strategies can still experience substantial losses.',
          fit:
            'Research Fit'
        },
        {
          name: 'Low-Frequency Rules-Based Swing Trading',
          summary:
            'Explore selective multi-day trades with predefined position size, stop level, and maximum portfolio exposure.',
          why:
            'This may provide opportunity without requiring constant screen time.',
          watch:
            'Excessive caution can make exits inconsistent with the original plan.',
          fit:
            'Flexible Research Fit'
        }
      ],

      E: [
        {
          name: 'Mean-Reversion Trading',
          summary:
            'Research objective definitions for overextension, exhaustion, confirmation, and invalidation before taking a reversal trade.',
          why:
            'This directly explores the type of stretched crowd behavior your profile may naturally notice.',
          watch:
            'Do not confuse extreme with ready to reverse.',
          fit:
            'Strong Research Fit'
        },
        {
          name: 'Sentiment-Driven Research',
          summary:
            'Explore how positioning, volatility, news reaction, and sentiment extremes can be incorporated into a repeatable process.',
          why:
            'This gives your independent thinking a structured evidence base.',
          watch:
            'Sentiment alone should not replace risk management or invalidation.',
          fit:
            'Strong Research Fit'
        },
        {
          name: 'High-IV Defined-Risk Premium Strategies',
          summary:
            'Research how implied volatility and defined-risk option structures behave around extreme conditions.',
          why:
            'This can connect your interest in extremes with measurable risk parameters.',
          watch:
            'High implied volatility often reflects real uncertainty.',
          fit:
            'Advanced Research Fit'
        }
      ]

    };


    /* =====================================================
       HELPERS
    ===================================================== */

    function getJSON(key) {

      try {

        var value =
          localStorage.getItem(
            key
          );

        return value
          ? JSON.parse(value)
          : null;

      }
      catch (error) {

        return null;

      }

    }


    function esc(value) {

      return String(
        value == null
          ? ''
          : value
      )
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');

    }


    function getDateObject(value) {

      var date =
        value
          ? new Date(value)
          : new Date();


      if (
        isNaN(
          date.getTime()
        )
      ) {

        date =
          new Date();

      }


      return date;

    }


    function formatDate(value) {

      var date =
        getDateObject(
          value
        );


      var month =
        String(
          date.getMonth() + 1
        ).padStart(
          2,
          '0'
        );


      var day =
        String(
          date.getDate()
        ).padStart(
          2,
          '0'
        );


      return (
        month +
        '/' +
        day +
        '/' +
        date.getFullYear()
      );

    }


    function formatTime(value) {

      var date =
        getDateObject(
          value
        );


      var hours =
        date.getHours();


      var minutes =
        String(
          date.getMinutes()
        ).padStart(
          2,
          '0'
        );


      var suffix =
        hours >= 12
          ? 'PM'
          : 'AM';


      var displayHours =
        hours % 12;


      if (
        displayHours === 0
      ) {

        displayHours =
          12;

      }


      return (
        displayHours +
        ':' +
        minutes +
        ' ' +
        suffix
      );

    }


    function formatDateTime(value) {

      return (
        formatDate(value) +
        ' • ' +
        formatTime(value)
      );

    }


    function makeList(
      items,
      danger
    ) {

      return items
      .map(
        function(item) {

          return (
            '<li>' +

              '<span class="bgs-r-bullet">' +
                (
                  danger
                    ? '!'
                    : '✓'
                ) +
              '</span>' +

              '<span>' +
                esc(item) +
              '</span>' +

            '</li>'
          );

        }
      )
      .join('');

    }


    function plainList(items) {

      return (
        '<ul>' +

          items
          .map(
            function(item) {

              return (
                '<li>' +
                  esc(item) +
                '</li>'
              );

            }
          )
          .join('') +

        '</ul>'
      );

    }


    function answerLetter(
      answers,
      number
    ) {

      return (
        answers[number] ||
        answers[String(number)] ||
        ''
      );

    }


    function sectionData(
      answers,
      sectionNumber
    ) {

      var range =
        SECTION_RANGES[
          sectionNumber
        ];


      var counts = {
        A: 0,
        B: 0,
        C: 0,
        D: 0,
        E: 0
      };


      for (
        var i = range[0];
        i <= range[1];
        i++
      ) {

        var letter =
          answerLetter(
            answers,
            i
          );


        if (
          counts.hasOwnProperty(
            letter
          )
        ) {

          counts[
            letter
          ] += 1;

        }

      }


      return {
        counts:
          counts,

        total:
          (
            range[1] -
            range[0]
          ) +
          1
      };

    }


    function getDominantSectionCards(
      answers,
      primary,
      secondary
    ) {

      var cards =
        [];


      for (
        var sectionNumber = 1;
        sectionNumber <= 6;
        sectionNumber++
      ) {

        var data =
          sectionData(
            answers,
            sectionNumber
          );


        var primaryCount =
          data.counts[
            primary
          ] || 0;


        var secondaryCount =
          data.counts[
            secondary
          ] || 0;


        cards.push({
          name:
            SECTION_NAMES[
              sectionNumber
            ],

          primaryCount:
            primaryCount,

          secondaryCount:
            secondaryCount,

          combined:
            primaryCount +
            secondaryCount,

          total:
            data.total
        });

      }


      cards.sort(
        function(a,b) {

          return (
            b.combined -
            a.combined
          );

        }
      );


      return cards.slice(
        0,
        3
      );

    }


    /* =====================================================
       TABS
    ===================================================== */

    var tabs =
      root.querySelectorAll(
        '[data-tab]'
      );


    Array.prototype
    .forEach
    .call(
      tabs,
      function(tab) {

        tab.addEventListener(
          'click',
          function() {

            var target =
              tab.getAttribute(
                'data-tab'
              );


            Array.prototype
            .forEach
            .call(
              tabs,
              function(item) {

                item.classList.toggle(
                  'is-active',
                  item === tab
                );

              }
            );


            var panels =
              root.querySelectorAll(
                '[data-panel]'
              );


            Array.prototype
            .forEach
            .call(
              panels,
              function(panel) {

                panel.classList.toggle(
                  'is-active',

                  panel.getAttribute(
                    'data-panel'
                  ) === target
                );

              }
            );

          }
        );

      }
    );


    /* =====================================================
       PERSONALITY EXPLORER
    ===================================================== */

    var explorer =
      root.querySelector(
        '[data-personality-explorer]'
      );


    var explorerOpen =
      root.querySelector(
        '[data-personality-open]'
      );


    var explorerClose =
      root.querySelector(
        '[data-personality-close]'
      );


    var personalityButtons =
      root.querySelector(
        '[data-personality-buttons]'
      );


    var personalityDetail =
      root.querySelector(
        '[data-personality-detail]'
      );


    function renderPersonalityDetail(letter) {

      var data =
        ARCHETYPES[
          letter
        ];


      if (!data) return;


      var buttons =
        personalityButtons.querySelectorAll(
          '[data-personality-letter]'
        );


      Array.prototype
      .forEach
      .call(
        buttons,
        function(button) {

          button.classList.toggle(
            'is-active',

            button.getAttribute(
              'data-personality-letter'
            ) === letter
          );

        }
      );


      personalityDetail.innerHTML =

        '<div class="bgs-r-explorer-primary">' +

          '<div>' +

            '<p class="bgs-r-explorer-eyebrow">' +
              'Trader Personality' +
            '</p>' +

            '<h2 class="bgs-r-explorer-name">' +
              esc(
                data.name
              ) +
            '</h2>' +

            '<p class="bgs-r-explorer-subtitle">' +
              esc(
                data.subtitle
              ) +
            '</p>' +

            '<p class="bgs-r-explorer-description">' +
              esc(
                data.description
              ) +
            '</p>' +

            '<div class="bgs-r-explorer-tags">' +

              data.tags
              .map(
                function(tag) {

                  return (
                    '<span class="bgs-r-explorer-tag">' +
                      esc(tag) +
                    '</span>'
                  );

                }
              )
              .join('') +

            '</div>' +

          '</div>' +


          '<div class="bgs-r-explorer-summary">' +

            '<div class="bgs-r-explorer-summary-item">' +
              '<small>Core Drive</small>' +
              '<strong>' +
                esc(data.coreDrive) +
              '</strong>' +
            '</div>' +

            '<div class="bgs-r-explorer-summary-item">' +
              '<small>How They Decide</small>' +
              '<strong>' +
                esc(data.decisionStyle) +
              '</strong>' +
            '</div>' +

            '<div class="bgs-r-explorer-summary-item">' +
              '<small>Where They Thrive</small>' +
              '<strong>' +
                esc(data.bestEnvironment) +
              '</strong>' +
            '</div>' +

            '<div class="bgs-r-explorer-summary-item">' +
              '<small>Under Pressure</small>' +
              '<strong>' +
                esc(data.pressurePattern) +
              '</strong>' +
            '</div>' +

          '</div>' +

        '</div>' +


        '<div class="bgs-r-explorer-lower">' +

          '<div class="bgs-r-explorer-card green">' +
            '<h3>Natural Strengths</h3>' +
            plainList(data.strengths) +
          '</div>' +

          '<div class="bgs-r-explorer-card red">' +
            '<h3>Common Watch Outs</h3>' +
            plainList(data.watchouts) +
          '</div>' +

          '<div class="bgs-r-explorer-card">' +
            '<h3>Helpful Guardrails</h3>' +
            plainList(data.guardrails) +
          '</div>' +

        '</div>';

    }


    function buildPersonalityExplorer(
      initialLetter
    ) {

      personalityButtons.innerHTML =
        ['A','B','C','D','E']
        .map(
          function(letter) {

            return (
              '<button ' +
                'type="button" ' +
                'class="bgs-r-personality-button" ' +
                'data-personality-letter="' +
                letter +
                '">' +

                esc(
                  ARCHETYPES[
                    letter
                  ].name
                ) +

              '</button>'
            );

          }
        )
        .join('');


      var buttons =
        personalityButtons.querySelectorAll(
          '[data-personality-letter]'
        );


      Array.prototype
      .forEach
      .call(
        buttons,
        function(button) {

          button.addEventListener(
            'click',
            function() {

              renderPersonalityDetail(
                button.getAttribute(
                  'data-personality-letter'
                )
              );

            }
          );

        }
      );


      renderPersonalityDetail(
        initialLetter || 'A'
      );

    }


    if (
      explorerOpen &&
      explorer
    ) {

      explorerOpen.addEventListener(
        'click',
        function() {

          explorer.hidden =
            false;


          explorer.scrollIntoView({
            behavior:
              'smooth',
            block:
              'start'
          });

        }
      );

    }


    if (
      explorerClose &&
      explorer
    ) {

      explorerClose.addEventListener(
        'click',
        function() {

          explorer.hidden =
            true;

        }
      );

    }


    /* =====================================================
       CURRENT RESULT
    ===================================================== */

    var CURRENT_RESULT =
      null;


    /* =====================================================
       PDF DONUT
    ===================================================== */

    function makePdfDonut(state) {

      var radius =
        52;


      var circumference =
        2 *
        Math.PI *
        radius;


      var primaryLength =
        circumference *
        state.primaryBlend /
        100;


      var secondaryLength =
        circumference -
        primaryLength;


      return (

        '<div class="pdf-blend-card">' +

          '<div class="pdf-chart-wrap">' +

            '<svg ' +
              'class="pdf-donut" ' +
              'viewBox="0 0 140 140" ' +
              'xmlns="http://www.w3.org/2000/svg">' +

              '<circle ' +
                'cx="70" ' +
                'cy="70" ' +
                'r="' +
                radius +
                '" ' +
                'fill="none" ' +
                'stroke="#ecece8" ' +
                'stroke-width="18"' +
              '/>' +

              '<circle ' +
                'cx="70" ' +
                'cy="70" ' +
                'r="' +
                radius +
                '" ' +
                'fill="none" ' +
                'stroke="#168943" ' +
                'stroke-width="18" ' +
                'stroke-dasharray="' +
                primaryLength +
                ' ' +
                secondaryLength +
                '" ' +
                'transform="rotate(-90 70 70)"' +
              '/>' +

              '<circle ' +
                'cx="70" ' +
                'cy="70" ' +
                'r="' +
                radius +
                '" ' +
                'fill="none" ' +
                'stroke="#aa92e6" ' +
                'stroke-width="18" ' +
                'stroke-dasharray="' +
                secondaryLength +
                ' ' +
                primaryLength +
                '" ' +
                'stroke-dashoffset="-' +
                primaryLength +
                '" ' +
                'transform="rotate(-90 70 70)"' +
              '/>' +

              '<text ' +
                'x="70" ' +
                'y="65" ' +
                'text-anchor="middle" ' +
                'font-family="Arial,Helvetica,sans-serif" ' +
                'font-size="24" ' +
                'font-weight="900" ' +
                'fill="#111111">' +

                state.primaryBlend +
                '%' +

              '</text>' +

              '<text ' +
                'x="70" ' +
                'y="82" ' +
                'text-anchor="middle" ' +
                'font-family="Arial,Helvetica,sans-serif" ' +
                'font-size="7" ' +
                'font-weight="800" ' +
                'letter-spacing="1" ' +
                'fill="#686868">' +

                'PRIMARY' +

              '</text>' +

            '</svg>' +

          '</div>' +

        '</div>'

      );

    }


    /* =====================================================
       PDF DOCUMENT
    ===================================================== */

    function buildPdfDocument(state) {

      var logoMarkup =
        PDF_LOGO
          ? (
            '<img ' +
              'class="pdf-logo" ' +
              'src="' +
              esc(PDF_LOGO) +
              '" ' +
              'alt="Black Girl Stocks">'
          )
          : '';


      var strategyMarkup =
        state.strategies
        .map(
          function(strategy,index) {

            return (

              '<div class="pdf-strategy">' +

                '<div class="pdf-strategy-number">' +
                  String(
                    index + 1
                  ).padStart(
                    2,
                    '0'
                  ) +
                '</div>' +

                '<div>' +

                  '<h3>' +
                    esc(
                      strategy.name
                    ) +
                  '</h3>' +

                  '<p>' +
                    esc(
                      strategy.summary
                    ) +
                  '</p>' +

                  '<p>' +
                    '<strong>Why it may fit:</strong> ' +
                    esc(
                      strategy.why
                    ) +
                  '</p>' +

                  '<p>' +
                    '<strong>Watch out for:</strong> ' +
                    esc(
                      strategy.watch
                    ) +
                  '</p>' +

                '</div>' +

              '</div>'

            );

          }
        )
        .join('');


      var css =
        '<style>' +

          '@page{' +
            'size:Letter;' +
            'margin:0;' +
          '}' +

          '*{' +
            'box-sizing:border-box;' +
          '}' +

          'html,body{' +
            'margin:0;' +
            'padding:0;' +
            'background:#fff;' +
            'color:#111;' +
            'font-family:Arial,Helvetica,sans-serif;' +
            '-webkit-print-color-adjust:exact;' +
            'print-color-adjust:exact;' +
          '}' +

          'body{' +
            'font-size:12px;' +
            'line-height:1.5;' +
          '}' +

          '.pdf-page{' +
            'width:8.5in;' +
            'min-height:11in;' +
            'margin:0 auto;' +
            'padding:.48in .55in;' +
            'background:#fff;' +
            'page-break-after:always;' +
          '}' +

          '.pdf-page:last-child{' +
            'page-break-after:auto;' +
          '}' +

          '.pdf-logo{' +
            'display:block;' +
            'width:155px;' +
            'max-height:62px;' +
            'object-fit:contain;' +
            'object-position:left center;' +
            'margin:0 0 22px;' +
          '}' +

          '.pdf-report-label{' +
            'margin:0 0 6px;' +
            'color:#168943;' +
            'font-size:8px;' +
            'font-weight:900;' +
            'letter-spacing:1.2px;' +
            'text-transform:uppercase;' +
          '}' +

          '.pdf-date-time{' +
            'display:inline-block;' +
            'margin:0 0 18px;' +
            'padding:7px 10px;' +
            'border:1px solid #d7e8d1;' +
            'border-radius:999px;' +
            'background:#eef8e9;' +
            'color:#116d36;' +
            'font-size:9px;' +
            'font-weight:900;' +
          '}' +

          '.pdf-hero{' +
            'display:grid;' +
            'grid-template-columns:minmax(0,1fr) 240px;' +
            'gap:28px;' +
            'align-items:center;' +
            'padding-bottom:25px;' +
            'border-bottom:1px solid #dedfd9;' +
          '}' +

          '.pdf-kicker{' +
            'margin:0 0 8px;' +
            'color:#168943;' +
            'font-size:8px;' +
            'font-weight:900;' +
            'letter-spacing:1.25px;' +
            'text-transform:uppercase;' +
          '}' +

          '.pdf-title{' +
            'margin:0 0 10px;' +
            'font-size:31px;' +
            'line-height:1.02;' +
            'letter-spacing:-1.2px;' +
            'font-weight:900;' +
          '}' +

          '.pdf-title span{' +
            'color:#168943;' +
          '}' +

          '.pdf-subtitle{' +
            'margin:0 0 10px;' +
            'font-size:14px;' +
            'font-weight:900;' +
          '}' +

          '.pdf-description{' +
            'margin:0;' +
            'color:#414441;' +
            'font-size:10px;' +
            'line-height:1.6;' +
          '}' +

          '.pdf-blend-card{' +
            'padding:15px;' +
            'border:1px solid #dedfd9;' +
            'border-radius:15px;' +
            'background:#fbfbfa;' +
          '}' +

          '.pdf-chart-wrap{' +
            'display:flex;' +
            'justify-content:center;' +
          '}' +

          '.pdf-donut{' +
            'display:block;' +
            'width:150px;' +
            'height:150px;' +
          '}' +

          '.pdf-section{' +
            'padding-top:21px;' +
          '}' +

          '.pdf-section-title{' +
            'margin:0 0 7px;' +
            'font-size:19px;' +
            'line-height:1.1;' +
            'font-weight:900;' +
          '}' +

          '.pdf-section-intro{' +
            'margin:0 0 14px;' +
            'color:#555;' +
            'font-size:9px;' +
            'line-height:1.55;' +
          '}' +

          '.pdf-grid-2{' +
            'display:grid;' +
            'grid-template-columns:repeat(2,minmax(0,1fr));' +
            'gap:11px;' +
          '}' +

          '.pdf-grid-4{' +
            'display:grid;' +
            'grid-template-columns:repeat(2,minmax(0,1fr));' +
            'gap:9px;' +
          '}' +

          '.pdf-box{' +
            'padding:13px;' +
            'border:1px solid #e2e3de;' +
            'border-radius:10px;' +
            'background:#fafafa;' +
            'break-inside:avoid;' +
          '}' +

          '.pdf-box.green{' +
            'background:#f7fbf4;' +
          '}' +

          '.pdf-box.red{' +
            'background:#fff3f0;' +
          '}' +

          '.pdf-box small{' +
            'display:block;' +
            'margin:0 0 5px;' +
            'color:#168943;' +
            'font-size:6px;' +
            'font-weight:900;' +
            'letter-spacing:.65px;' +
            'text-transform:uppercase;' +
          '}' +

          '.pdf-box strong{' +
            'display:block;' +
            'font-size:9px;' +
            'line-height:1.45;' +
          '}' +

          '.pdf-box h3{' +
            'margin:0 0 8px;' +
            'font-size:12px;' +
          '}' +

          '.pdf-box ul{' +
            'margin:0;' +
            'padding-left:15px;' +
          '}' +

          '.pdf-box li{' +
            'margin-bottom:5px;' +
            'font-size:8px;' +
            'line-height:1.45;' +
          '}' +

          '.pdf-strategy{' +
            'display:grid;' +
            'grid-template-columns:40px minmax(0,1fr);' +
            'gap:12px;' +
            'padding:13px;' +
            'margin-bottom:9px;' +
            'border:1px solid #dedfd9;' +
            'border-radius:11px;' +
            'break-inside:avoid;' +
          '}' +

          '.pdf-strategy-number{' +
            'width:36px;' +
            'height:36px;' +
            'display:flex;' +
            'align-items:center;' +
            'justify-content:center;' +
            'border-radius:9px;' +
            'background:#eef8e9;' +
            'color:#168943;' +
            'font-size:8px;' +
            'font-weight:900;' +
          '}' +

          '.pdf-strategy h3{' +
            'margin:0 0 5px;' +
            'font-size:11px;' +
          '}' +

          '.pdf-strategy p{' +
            'margin:0 0 4px;' +
            'font-size:8px;' +
            'line-height:1.4;' +
          '}' +

          '.pdf-callout{' +
            'padding:13px;' +
            'border-radius:11px;' +
            'background:#eef8e9;' +
          '}' +

          '.pdf-callout p{' +
            'margin:0;' +
            'font-size:8px;' +
            'line-height:1.5;' +
          '}' +

          '.pdf-disclaimer{' +
            'margin-top:20px;' +
            'padding-top:10px;' +
            'border-top:1px solid #dedfd9;' +
            'color:#666;' +
            'font-size:6px;' +
            'line-height:1.4;' +
          '}' +

        '</style>';


      var pageOne =
        '<section class="pdf-page">' +

          logoMarkup +

          '<p class="pdf-report-label">' +
            'Trader Personality Alignment Results' +
          '</p>' +

          '<div class="pdf-date-time">' +
            'Assessment Date & Time: ' +
            esc(
              state.dateTime
            ) +
          '</div>' +

          '<div class="pdf-hero">' +

            '<div>' +

              '<p class="pdf-kicker">' +
                'Your Trader Personality Alignment' +
              '</p>' +

              '<h1 class="pdf-title">' +
                'You’re ' +
                esc(
                  state.primaryData.article
                ) +
                ' <span>' +
                esc(
                  state.primaryData.name
                ) +
                '.</span>' +
              '</h1>' +

              '<p class="pdf-subtitle">' +
                esc(
                  state.primaryData.subtitle
                ) +
              '</p>' +

              '<p class="pdf-description">' +
                esc(
                  state.primaryData.description
                ) +
              '</p>' +

            '</div>' +

            makePdfDonut(
              state
            ) +

          '</div>' +

          '<div class="pdf-section">' +

            '<p class="pdf-kicker">' +
              'Your Trading DNA' +
            '</p>' +

            '<h2 class="pdf-section-title">' +
              'How your personality tends to show up in the market' +
            '</h2>' +

            '<div class="pdf-grid-4">' +

              '<div class="pdf-box">' +

                '<small>What Drives You</small>' +

                '<strong>' +
                  esc(
                    state.primaryData.coreDrive
                  ) +
                '</strong>' +

              '</div>' +

              '<div class="pdf-box">' +

                '<small>How You Decide</small>' +

                '<strong>' +
                  esc(
                    state.primaryData.decisionStyle
                  ) +
                '</strong>' +

              '</div>' +

              '<div class="pdf-box">' +

                '<small>Where You Thrive</small>' +

                '<strong>' +
                  esc(
                    state.primaryData.bestEnvironment
                  ) +
                '</strong>' +

              '</div>' +

              '<div class="pdf-box">' +

                '<small>Your Secondary Edge</small>' +

                '<strong>' +
                  esc(
                    state.secondaryData.name
                  ) +
                '</strong>' +

              '</div>' +

            '</div>' +

          '</div>' +

          '<div class="pdf-section">' +

            '<h2 class="pdf-section-title">' +
              'What this blend means' +
            '</h2>' +

            '<p class="pdf-section-intro">' +
              esc(
                state.blendCopy
              ) +
            '</p>' +

          '</div>' +

        '</section>';


      var pageTwo =
        '<section class="pdf-page">' +

          '<p class="pdf-kicker">' +
            'Your Full Personality Profile' +
          '</p>' +

          '<h2 class="pdf-section-title">' +
            'What it means to be ' +
            esc(
              state.primaryData.article
            ) +
            ' ' +
            esc(
              state.primaryData.name
            ) +
          '</h2>' +

          '<p class="pdf-section-intro">' +
            esc(
              state.primaryData.description
            ) +
          '</p>' +

          '<div class="pdf-grid-2">' +

            '<div class="pdf-box green">' +

              '<h3>Natural Strengths</h3>' +

              plainList(
                state.primaryData.strengths
              ) +

            '</div>' +

            '<div class="pdf-box red">' +

              '<h3>Common Watch Outs</h3>' +

              plainList(
                state.primaryData.watchouts
              ) +

            '</div>' +

          '</div>' +

          '<div class="pdf-section">' +

            '<h2 class="pdf-section-title">' +
              'Helpful Guardrails' +
            '</h2>' +

            '<div class="pdf-box">' +

              plainList(
                state.primaryData.guardrails
              ) +

            '</div>' +

          '</div>' +

          '<div class="pdf-section">' +

            '<h2 class="pdf-section-title">' +
              'When This Style Works Best' +
            '</h2>' +

            '<div class="pdf-box">' +

              plainList(
                state.primaryData.best
              ) +

            '</div>' +

          '</div>' +

        '</section>';


      var pageThree =
        '<section class="pdf-page">' +

          '<p class="pdf-kicker">' +
            'Strategy Research' +
          '</p>' +

          '<h2 class="pdf-section-title">' +
            'Strategies & Systems to Research' +
          '</h2>' +

          '<p class="pdf-section-intro">' +
            'These are educational starting points based on your primary and secondary personality influences. A personality match does not make a strategy profitable or appropriate for every account.' +
          '</p>' +

          strategyMarkup +

          '<div class="pdf-section">' +

            '<h2 class="pdf-section-title">' +
              'Why You Received This Result' +
            '</h2>' +

            '<div class="pdf-callout">' +

              '<p>' +
                esc(
                  state.whyCopy
                ) +
              '</p>' +

            '</div>' +

          '</div>' +

          '<div class="pdf-section">' +

            '<h2 class="pdf-section-title">' +
              'Your Next Step' +
            '</h2>' +

            '<div class="pdf-callout">' +

              '<p>' +
                esc(
                  state.nextCopy
                ) +
              '</p>' +

            '</div>' +

          '</div>' +

          '<div class="pdf-disclaimer">' +

            '<strong>Black Girl Stocks</strong><br>' +

            'For educational and self-reflection purposes only. ' +
            'This assessment is not financial advice, investment advice, ' +
            'or a clinical psychological evaluation.' +

          '</div>' +

        '</section>';


      return (
        '<!doctype html>' +
        '<html>' +
        '<head>' +
          '<meta charset="utf-8">' +
          '<meta name="viewport" content="width=device-width,initial-scale=1">' +
          '<title>BGS Trader Personality Results</title>' +
          css +
        '</head>' +
        '<body>' +
          pageOne +
          pageTwo +
          pageThree +
        '</body>' +
        '</html>'
      );

    }


    /* =====================================================
       PDF BUTTON
    ===================================================== */

    var pdfButton =
      root.querySelector(
        '[data-pdf-results]'
      );


    if (pdfButton) {

      pdfButton.addEventListener(
        'click',
        function() {

          if (!CURRENT_RESULT) {
            return;
          }


          var popup =
            window.open(
              '',
              '_blank',
              'width=1000,height=900'
            );


          if (!popup) {

            alert(
              'Please allow pop-ups so your PDF results can open.'
            );

            return;

          }


          popup.document.open();


          popup.document.write(
            buildPdfDocument(
              CURRENT_RESULT
            )
          );


          popup.document.close();


          popup.document.title =
            'BGS-Trader-Personality-Results';


          setTimeout(
            function() {

              popup.focus();

              popup.print();

            },
            900
          );

        }
      );

    }


    /* =====================================================
       RETAKE
    ===================================================== */

    var retake =
      root.querySelector(
        '[data-retake-quiz]'
      );


    if (retake) {

      retake.addEventListener(
        'click',
        function() {

          root.hidden =
            true;


          window.dispatchEvent(
            new CustomEvent(
              'bgs:retake-trader-quiz'
            )
          );

        }
      );

    }


    /* =====================================================
       RESULTS RENDERER

       IMPORTANT:
       RESULTS ONLY APPEAR AFTER THE QUIZ CALLS THIS.
    ===================================================== */

    window.BGSRenderTraderResults =
      function () {

        var result =
          getJSON(
            'bgsTraderPersonalityScoresV1'
          );


        var answers =
          getJSON(
            'bgsTraderPersonalityAnswersV1'
          );


        if (
          !result ||
          !result.scores ||
          !answers
        ) {

          return;

        }


        var scores =
          result.scores;


        var ranked =
          ['A','B','C','D','E']
          .sort(
            function(a,b) {

              return (
                scores[b] -
                scores[a]
              );

            }
          );


        var primary =
          result.primary ||
          ranked[0];


        var secondary =
          result.secondary ||
          ranked[1];


        var primaryData =
          ARCHETYPES[
            primary
          ];


        var secondaryData =
          ARCHETYPES[
            secondary
          ];


        if (
          !primaryData ||
          !secondaryData
        ) {

          return;

        }


        var completedAt =
          result.completedAt;


        if (!completedAt) {

          completedAt =
            new Date()
            .toISOString();


          result.completedAt =
            completedAt;


          try {

            localStorage.setItem(
              'bgsTraderPersonalityScoresV1',
              JSON.stringify(
                result
              )
            );

          }
          catch (error) {}

        }


        var assessmentDate =
          formatDate(
            completedAt
          );


        var assessmentTime =
          formatTime(
            completedAt
          );


        var assessmentDateTime =
          formatDateTime(
            completedAt
          );


        var topTotal =
          Math.max(
            1,
            scores[primary] +
            scores[secondary]
          );


        var primaryBlend =
          Math.round(
            scores[primary] /
            topTotal *
            100
          );


        var secondaryBlend =
          100 -
          primaryBlend;


        var strategies =
          STRATEGIES[
            primary
          ] || [];


        buildPersonalityExplorer(
          primary
        );


        var dateNode =
          root.querySelector(
            '[data-assessment-date]'
          );


        if (dateNode) {

          dateNode.textContent =
            'Assessment Date & Time: ' +
            assessmentDateTime;

        }


        root.querySelector(
          '[data-blend-donut]'
        ).style.setProperty(
          '--primary-deg',
          (
            primaryBlend /
            100 *
            360
          ) +
          'deg'
        );


        root.querySelector(
          '[data-primary-blend]'
        ).textContent =
          primaryBlend +
          '%';


        root.querySelector(
          '[data-primary-name]'
        ).textContent =
          primaryData.name;


        root.querySelector(
          '[data-secondary-name]'
        ).textContent =
          secondaryData.name;


        root.querySelector(
          '[data-primary-percent]'
        ).textContent =
          primaryBlend +
          '%';


        root.querySelector(
          '[data-secondary-percent]'
        ).textContent =
          secondaryBlend +
          '%';


        var blendCopy =
          primaryData.blend +
          ' Your ' +
          secondaryData.name +
          ' influence adds traits associated with ' +
          secondaryData.coreDrive.toLowerCase();


        root.querySelector(
          '[data-blend-explainer]'
        ).textContent =
          blendCopy;


        root.querySelector(
          '[data-result-title]'
        ).innerHTML =
          'You’re ' +
          esc(
            primaryData.article
          ) +
          ' <span>' +
          esc(
            primaryData.name
          ) +
          '.</span>';


        root.querySelector(
          '[data-result-subtitle]'
        ).textContent =
          primaryData.subtitle;


        root.querySelector(
          '[data-result-description]'
        ).textContent =
          primaryData.description;


        root.querySelector(
          '[data-result-tags]'
        ).innerHTML =
          primaryData.tags
          .map(
            function(tag) {

              return (
                '<span class="bgs-r-tag">' +
                  esc(tag) +
                '</span>'
              );

            }
          )
          .join('');


        var dnaItems = [

          {
            icon: '↗',
            label: 'What Drives You',
            title:
              primaryData.coreDrive,
            copy:
              'This is the motivation that appeared most consistently across your responses and helps explain what tends to keep you engaged.'
          },

          {
            icon: '◆',
            label: 'How You Decide',
            title:
              primaryData.decisionStyle,
            copy:
              'This reflects the way you tend to process information and move from observation into action.'
          },

          {
            icon: '◉',
            label: 'Where You Thrive',
            title:
              primaryData.bestEnvironment,
            copy:
              'These are the kinds of conditions that may feel more natural for your pace, attention, and decision-making style.'
          },

          {
            icon: '✦',
            label: 'Your Secondary Edge',
            title:
              secondaryData.name,
            copy:
              secondaryData.coreDrive +
              ' This secondary influence adds another layer to how your primary personality may show up in actual trading decisions.'
          }

        ];


        root.querySelector(
          '[data-trading-dna]'
        ).innerHTML =
          dnaItems
          .map(
            function(item) {

              return (
                '<article class="bgs-r-dna-item">' +

                  '<div class="bgs-r-dna-icon">' +
                    esc(item.icon) +
                  '</div>' +

                  '<span class="bgs-r-dna-label">' +
                    esc(item.label) +
                  '</span>' +

                  '<h3>' +
                    esc(item.title) +
                  '</h3>' +

                  '<p>' +
                    esc(item.copy) +
                  '</p>' +

                '</article>'
              );

            }
          )
          .join('');


        root.querySelector(
          '[data-distribution]'
        ).innerHTML =
          ['A','B','C','D','E']
          .map(
            function(letter) {

              var width =
                Math.round(
                  (
                    scores[
                      letter
                    ] || 0
                  ) /
                  50 *
                  100
                );


              return (
                '<div class="bgs-r-bar-row">' +

                  '<div class="bgs-r-bar-label">' +
                    esc(
                      ARCHETYPES[
                        letter
                      ].name
                    ) +
                  '</div>' +

                  '<div class="bgs-r-track">' +
                    '<span style="width:' +
                    width +
                    '%"></span>' +
                  '</div>' +

                  '<div class="bgs-r-bar-number">' +
                    (
                      scores[
                        letter
                      ] || 0
                    ) +
                  '</div>' +

                '</div>'
              );

            }
          )
          .join('');


        root.querySelector(
          '[data-category-bars]'
        ).innerHTML =
          [1,2,3,4,5,6]
          .map(
            function(sectionNumber) {

              var data =
                sectionData(
                  answers,
                  sectionNumber
                );


              var aligned =
                (
                  data.counts[
                    primary
                  ] || 0
                ) +
                (
                  data.counts[
                    secondary
                  ] || 0
                );


              var percent =
                Math.round(
                  aligned /
                  data.total *
                  100
                );


              return (
                '<div class="bgs-r-bar-row">' +

                  '<div class="bgs-r-bar-label">' +
                    esc(
                      SECTION_NAMES[
                        sectionNumber
                      ]
                    ) +
                  '</div>' +

                  '<div class="bgs-r-track">' +
                    '<span style="width:' +
                    percent +
                    '%"></span>' +
                  '</div>' +

                  '<div class="bgs-r-bar-number">' +
                    percent +
                    '%' +
                  '</div>' +

                '</div>'
              );

            }
          )
          .join('');


        root.querySelector(
          '[data-profile]'
        ).innerHTML =

          '<p class="bgs-r-section-kicker">' +
            'Your Full Personality Profile' +
          '</p>' +

          '<h2 class="bgs-r-section-title">' +
            'What it means to be ' +
            esc(
              primaryData.article
            ) +
            ' ' +
            esc(
              primaryData.name
            ) +
          '</h2>' +

          '<p class="bgs-r-section-copy">' +
            esc(
              primaryData.description
            ) +
            ' This is not a fixed identity or a prediction of trading performance. It is a practical way to interpret the tendencies that appeared most often across your answers.' +
          '</p>' +

          '<div class="bgs-r-profile-grid">' +

            '<div class="bgs-r-profile-block">' +
              '<small>Core Drive</small>' +
              '<strong>' +
                esc(
                  primaryData.coreDrive
                ) +
              '</strong>' +
            '</div>' +

            '<div class="bgs-r-profile-block">' +
              '<small>Decision Style</small>' +
              '<strong>' +
                esc(
                  primaryData.decisionStyle
                ) +
              '</strong>' +
            '</div>' +

            '<div class="bgs-r-profile-block">' +
              '<small>At Your Best</small>' +
              '<strong>' +
                esc(
                  primaryData.bestEnvironment
                ) +
              '</strong>' +
            '</div>' +

            '<div class="bgs-r-profile-block">' +
              '<small>Under Pressure</small>' +
              '<strong>' +
                esc(
                  primaryData.pressurePattern
                ) +
              '</strong>' +
            '</div>' +

          '</div>';


        root.querySelector(
          '[data-strength-list]'
        ).innerHTML =
          makeList(
            primaryData.strengths,
            false
          );


        root.querySelector(
          '[data-best-list]'
        ).innerHTML =
          makeList(
            primaryData.best,
            false
          );


        root.querySelector(
          '[data-watch-list]'
        ).innerHTML =
          makeList(
            primaryData.watchouts,
            true
          );


        root.querySelector(
          '[data-guardrail-list]'
        ).innerHTML =
          makeList(
            primaryData.guardrails,
            false
          );


        root.querySelector(
          '[data-strategy-intro]'
        ).textContent =
          'These are educational starting points to research based on your ' +
          primaryData.name +
          ' result and your ' +
          secondaryData.name +
          ' secondary influence. They are not instructions to place a trade, and a personality match does not make a strategy profitable or appropriate for every account.';


        root.querySelector(
          '[data-strategy-list]'
        ).innerHTML =
          strategies
          .map(
            function(strategy,index) {

              var number =
                String(
                  index + 1
                ).padStart(
                  2,
                  '0'
                );


              return (
                '<article class="bgs-r-strategy-row">' +

                  '<div>' +

                    '<div class="bgs-r-strategy-number">' +
                      number +
                    '</div>' +

                  '</div>' +

                  '<div class="bgs-r-strategy-name">' +

                    '<h3>' +
                      esc(
                        strategy.name
                      ) +
                    '</h3>' +

                    '<p>' +
                      esc(
                        strategy.summary
                      ) +
                    '</p>' +

                  '</div>' +

                  '<div class="bgs-r-strategy-main">' +

                    '<span class="bgs-r-mini-label">' +
                      'Why it may fit' +
                    '</span>' +

                    '<p>' +
                      esc(
                        strategy.why
                      ) +
                    '</p>' +

                    '<span class="bgs-r-fit-pill">' +
                      esc(
                        strategy.fit
                      ) +
                    '</span>' +

                  '</div>' +

                  '<div class="bgs-r-strategy-side">' +

                    '<span class="bgs-r-mini-label">' +
                      'Watch Out For' +
                    '</span>' +

                    '<p>' +
                      esc(
                        strategy.watch
                      ) +
                    '</p>' +

                  '</div>' +

                '</article>'
              );

            }
          )
          .join('');


        var margin =
          (
            scores[
              primary
            ] || 0
          ) -
          (
            scores[
              secondary
            ] || 0
          );


        var whyCopy =
          'Across all 50 questions, ' +
          primaryData.name +
          ' received ' +
          (
            scores[
              primary
            ] || 0
          ) +
          ' responses and ' +
          secondaryData.name +
          ' received ' +
          (
            scores[
              secondary
            ] || 0
          ) +
          '. That is a margin of ' +
          margin +
          ' response' +
          (
            margin === 1
              ? ''
              : 's'
          ) +
          '.';


        root.querySelector(
          '[data-why-heading]'
        ).textContent =
          'Why ' +
          primaryData.name +
          ' rose to the top';


        root.querySelector(
          '[data-why-copy]'
        ).textContent =
          whyCopy;


        var reasonCards =
          getDominantSectionCards(
            answers,
            primary,
            secondary
          );


        root.querySelector(
          '[data-reason-grid]'
        ).innerHTML =
          reasonCards
          .map(
            function(item) {

              return (
                '<div class="bgs-r-reason">' +

                  '<span class="bgs-r-mini-label">' +
                    esc(
                      item.name
                    ) +
                  '</span>' +

                  '<strong>' +
                    item.combined +
                    ' of ' +
                    item.total +
                    ' answers matched your top two styles' +
                  '</strong>' +

                  '<p>' +
                    esc(
                      primaryData.name
                    ) +
                    ' appeared ' +
                    item.primaryCount +
                    ' time' +
                    (
                      item.primaryCount === 1
                        ? ''
                        : 's'
                    ) +
                    ', while ' +
                    esc(
                      secondaryData.name
                    ) +
                    ' appeared ' +
                    item.secondaryCount +
                    ' time' +
                    (
                      item.secondaryCount === 1
                        ? ''
                        : 's'
                    ) +
                    ' in this category.' +
                  '</p>' +

                '</div>'
              );

            }
          )
          .join('');


        var nextCopy =
          'For your ' +
          primaryData.name +
          ' profile, the goal is not to force yourself into a different personality. Build structure around the tendencies you already have. Choose one strategy or system to research, define the behaviors you want to reinforce, and track enough real data to see whether the process actually fits you.';


        root.querySelector(
          '[data-next-copy]'
        ).textContent =
          nextCopy;


        CURRENT_RESULT = {

          completedAt:
            completedAt,

          date:
            assessmentDate,

          time:
            assessmentTime,

          dateTime:
            assessmentDateTime,

          primary:
            primary,

          secondary:
            secondary,

          primaryData:
            primaryData,

          secondaryData:
            secondaryData,

          primaryBlend:
            primaryBlend,

          secondaryBlend:
            secondaryBlend,

          blendCopy:
            blendCopy,

          strategies:
            strategies,

          whyCopy:
            whyCopy,

          nextCopy:
            nextCopy

        };


        explorer.hidden =
          true;


        root.hidden =
          false;


        root.scrollIntoView({
          behavior:
            'smooth',
          block:
            'start'
        });

      };

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initBGSResults
    );

  }
  else {

    initBGSResults();

  }

})();